/*******************************************************************************/
/* Type guards
/*******************************************************************************/
export const isCommand = (command) => {
    if (!command)
        return false;
    if (!command.hasOwnProperty('text'))
        return false;
    if (!command.hasOwnProperty('id'))
        return false;
    if (!command.hasOwnProperty('organization'))
        return false;
    if (!command.hasOwnProperty('arguments'))
        return false;
    return true;
};
export const isResource = (option) => {
    if (option && option._cbLinkedCommands)
        return true;
    return false;
};
export const isContextArgument = (argument) => {
    return argument.type === 'context';
};
export const isTimeArgument = (argument) => {
    return argument.type === 'provided' && argument.value === 'time';
};
export const isFunctionArgument = (argument) => {
    return argument.type === 'function';
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidHlwZXMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvbWlkZGxld2FyZS90eXBlcy50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBMEdBLGlGQUFpRjtBQUNqRjtpRkFDaUY7QUFDakYsTUFBTSxDQUFDLE1BQU0sU0FBUyxHQUFHLENBQUMsT0FBNEIsRUFBMkIsRUFBRTtJQUNqRixJQUFJLENBQUMsT0FBTztRQUFFLE9BQU8sS0FBSyxDQUFDO0lBQzNCLElBQUksQ0FBQyxPQUFPLENBQUMsY0FBYyxDQUFDLE1BQU0sQ0FBQztRQUFFLE9BQU8sS0FBSyxDQUFDO0lBQ2xELElBQUksQ0FBQyxPQUFPLENBQUMsY0FBYyxDQUFDLElBQUksQ0FBQztRQUFFLE9BQU8sS0FBSyxDQUFDO0lBQ2hELElBQUksQ0FBQyxPQUFPLENBQUMsY0FBYyxDQUFDLGNBQWMsQ0FBQztRQUFFLE9BQU8sS0FBSyxDQUFDO0lBQzFELElBQUksQ0FBQyxPQUFPLENBQUMsY0FBYyxDQUFDLFdBQVcsQ0FBQztRQUFFLE9BQU8sS0FBSyxDQUFDO0lBQ3ZELE9BQU8sSUFBSSxDQUFDO0FBQ2QsQ0FBQyxDQUFDO0FBRUYsTUFBTSxDQUFDLE1BQU0sVUFBVSxHQUFHLENBQUMsTUFBVyxFQUEyQixFQUFFO0lBQ2pFLElBQUksTUFBTSxJQUFLLE1BQXdCLENBQUMsaUJBQWlCO1FBQUUsT0FBTyxJQUFJLENBQUM7SUFDdkUsT0FBTyxLQUFLLENBQUM7QUFDZixDQUFDLENBQUM7QUFFRixNQUFNLENBQUMsTUFBTSxpQkFBaUIsR0FBRyxDQUFDLFFBQXVCLEVBQW9DLEVBQUU7SUFDN0YsT0FBTyxRQUFRLENBQUMsSUFBSSxLQUFLLFNBQVMsQ0FBQztBQUNyQyxDQUFDLENBQUM7QUFFRixNQUFNLENBQUMsTUFBTSxjQUFjLEdBQUcsQ0FBQyxRQUF1QixFQUFvQyxFQUFFO0lBQzFGLE9BQU8sUUFBUSxDQUFDLElBQUksS0FBSyxVQUFVLElBQUksUUFBUSxDQUFDLEtBQUssS0FBSyxNQUFNLENBQUM7QUFDbkUsQ0FBQyxDQUFDO0FBRUYsTUFBTSxDQUFDLE1BQU0sa0JBQWtCLEdBQUcsQ0FBQyxRQUF1QixFQUFxQyxFQUFFO0lBQy9GLE9BQU8sUUFBUSxDQUFDLElBQUksS0FBSyxVQUFVLENBQUM7QUFDdEMsQ0FBQyxDQUFDIn0=